import { GD } from "../GD"

export class Accounts{

    constructor(){
       // GD.B_ACCOUNTS.listener=async req=>this.getAccount(req)
       GD.REQ_ACCOUNT.listener=async req=>this.getAccount(req)
       GD.REQ_ACCOUNT_BY_UID.listener=async req=>this.getAccountByUID(req)
    }

    async getAccount(req:{userUID:string}){
        const response = await GD.REQ_API.request({ method:"account/get", data:{userUID:req.userUID} })
        return response;
    }
    async getAccountByUID({uid}:{uid:string}){
        // DETERMINE PROJECT AND USER
        const response = await GD.REQ_API.request({ method:"account/get", data:{uid:uid} })
        return response;
    }


    
}